function Avatar(props) {
  return (
    <img alt="" src={props.src} className={props.size === 'large' ? 'w-8 h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 rounded-full' : 'w-4 h-4 md:w-5 md:h-5 lg:w-6 lg:h-6 rounded-full'} />
  );
}

export default Avatar
